@if (primary) {
  <div class="lds-dual-ring border-color-primary"></div>
}

@if (!primary) {
  <div class="lds-dual-ring border-color-secondary"></div>
}